export default __webpack_public_path__ + "img/googleplaystore.c41c0c05.png";